/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

export type BystanderTreatmentDataTreatmentEnum =
  (typeof BystanderTreatmentDataTreatmentEnum)[keyof typeof BystanderTreatmentDataTreatmentEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BystanderTreatmentDataTreatmentEnum = {
  COVERING: 'COVERING',
  POSITION_MANAGEMENT: 'POSITION_MANAGEMENT',
  WARMING: 'WARMING',
  COOLING: 'COOLING',
  IMMOBILIZATION: 'IMMOBILIZATION',
  ARTIFICIAL_RESPIRATION: 'ARTIFICIAL_RESPIRATION',
  CHEST_COMPRESSION: 'CHEST_COMPRESSION',
  AIRWAY_OBSTRUCTION_REMOVAL: 'AIRWAY_OBSTRUCTION_REMOVAL',
  AED: 'AED',
  HEMOSTASIS: 'HEMOSTASIS',
  OTHER: 'OTHER',
} as const;
